import { type IngredientMeasure } from "@fitness-app/data-models/entities/Ingredient";

export const measuresMap: Record<string, IngredientMeasure> = {
  "1": {
    id: 1,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "none",
    unit: "gram",
    defaultValue: null,
  },
  "2": {
    id: 2,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "handful",
    unit: "gram",
    defaultValue: null,
  },
  "3": {
    id: 3,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "spoon",
    unit: "gram",
    defaultValue: null,
  },
  "4": {
    id: 4,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "piece",
    unit: "gram",
    defaultValue: null,
  },
  "5": {
    id: 5,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "liter",
    unit: "ml",
    defaultValue: 1000,
  },
  "7": {
    id: 7,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "portion",
    unit: "gram",
    defaultValue: null,
  },
  "8": {
    id: 8,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "smallSlice",
    unit: "gram",
    defaultValue: null,
  },
  "9": {
    id: 9,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "package",
    unit: "gram",
    defaultValue: null,
  },
  "10": {
    id: 10,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "teaspoon",
    unit: "gram",
    defaultValue: null,
  },
  "12": {
    id: 12,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "slice",
    unit: "gram",
    defaultValue: null,
  },
  "13": {
    id: 13,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "glass",
    unit: "gram",
    defaultValue: null,
  },
  "14": {
    id: 14,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "cube",
    unit: "gram",
    defaultValue: null,
  },
  "15": {
    id: 15,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "clove",
    unit: "gram",
    defaultValue: null,
  },
  "16": {
    id: 16,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "leaf",
    unit: "gram",
    defaultValue: null,
  },
  "17": {
    id: 17,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "stalk",
    unit: "gram",
    defaultValue: null,
  },
  "19": {
    id: 19,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "drop",
    unit: "gram",
    defaultValue: null,
  },
  "20": {
    id: 20,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "pinch",
    unit: "gram",
    defaultValue: null,
  },
  "21": {
    id: 21,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "flake",
    unit: "gram",
    defaultValue: null,
  },
  "22": {
    id: 22,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "tube",
    unit: "gram",
    defaultValue: null,
  },
  "23": {
    id: 23,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "capsule",
    unit: "gram",
    defaultValue: null,
  },
  "24": {
    id: 24,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "scoop",
    unit: "gram",
    defaultValue: null,
  },
  "25": {
    id: 25,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "bunch",
    unit: "gram",
    defaultValue: null,
  },
  "26": {
    id: 26,
    createdAt: "2023-06-20T16:44:14.386123+00:00",
    updatedAt: "2023-06-20T16:44:14.386123+00:00",
    name: "tablet",
    unit: "gram",
    defaultValue: null,
  },
};
